<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>{{ 'ADMINISTRATION.EMAIL_LABELING_SETTINGS.TITLE' | translate }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <glxy-form-field [bottomSpacing]="'default'">
      <glxy-label>{{ 'ADMINISTRATION.EMAIL_LABELING_SETTINGS.CONFIG_NAME' | translate }}</glxy-label>
      <input
        matInput
        [value]="configurationName()"
        [maxLength]="maxConfigNameLength"
        (input)="onConfigNameChange($any($event.target).value)"
        [placeholder]="'ADMINISTRATION.EMAIL_LABELING_SETTINGS.CONFIG_NAME_PLACEHOLDER' | translate"
        required
      />
      @if (configurationName().trim().length === 0) {
        <glxy-error>
          {{ 'ADMINISTRATION.EMAIL_LABELING_SETTINGS.CONFIG_NAME_REQUIRED' | translate }}
        </glxy-error>
      }
    </glxy-form-field>

    <h3>{{ 'ADMINISTRATION.EMAIL_LABELING_SETTINGS.LABELS_HEADER' | translate }}</h3>

    @for (label of labels(); track label.position) {
      <div class="label-row">
        <div class="label-position">
          {{ label.position }}
        </div>

        <div class="label-color-preview" [style.backgroundColor]="label.colorHex"></div>

        <glxy-form-field [bottomSpacing]="'none'">
          <input
            matInput
            [value]="label.name"
            [maxLength]="maxNameLength"
            (input)="onNameChange(label.position, $any($event.target).value)"
            [placeholder]="'ADMINISTRATION.EMAIL_LABELING_SETTINGS.ENTER_LABEL_NAME' | translate"
          />
        </glxy-form-field>

        <glxy-form-field [bottomSpacing]="'none'">
          <input
            matInput
            [value]="label.description || ''"
            [maxLength]="maxDescriptionLength"
            (input)="onDescriptionChange(label.position, $any($event.target).value)"
            [placeholder]="'ADMINISTRATION.EMAIL_LABELING_SETTINGS.LABEL_DESCRIPTION' | translate"
          />
        </glxy-form-field>

        <glxy-form-field [bottomSpacing]="'none'">
          <mat-select [value]="label.colorHex" (selectionChange)="onColorChange(label.position, $event.value)">
            @for (color of colors; track color.hex) {
              <mat-option [value]="color.hex">{{ color.name }}</mat-option>
            }
          </mat-select>
        </glxy-form-field>

        <button
          mat-icon-button
          type="button"
          color="warn"
          (click)="removeLabel(label.position)"
          [disabled]="labels().length <= 1"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    }

    <button
      mat-stroked-button
      type="button"
      (click)="addLabel()"
      [disabled]="labels().length >= maxLabels"
      class="add-label-button"
    >
      <mat-icon>add</mat-icon>
      {{ 'ADMINISTRATION.EMAIL_LABELING_SETTINGS.ADD_LABEL' | translate }}
    </button>

    <glxy-form-field [bottomSpacing]="'default'">
      <glxy-label>{{ 'ADMINISTRATION.EMAIL_LABELING_SETTINGS.TRACKING_MODE' | translate }}</glxy-label>
      <mat-select [value]="trackingMode()" (selectionChange)="trackingMode.set($event.value)">
        <mat-select-trigger>{{ selectedTrackingModeLabelKey() | translate }}</mat-select-trigger>
        @for (option of trackingModeOptions; track option.value) {
          <mat-option [value]="option.value">{{ option.labelKey | translate }}</mat-option>
        }
      </mat-select>
      <glxy-hint>{{ 'ADMINISTRATION.EMAIL_LABELING_SETTINGS.TRACKING_MODE_HELP' | translate }}</glxy-hint>
    </glxy-form-field>

    <glxy-form-field [bottomSpacing]="'default'">
      <glxy-label>{{ 'ADMINISTRATION.EMAIL_LABELING_SETTINGS.DEFAULT_INBOUND_VISIBILITY' | translate }}</glxy-label>
      <mat-select [value]="defaultInboundVisibility()" (selectionChange)="defaultInboundVisibility.set($event.value)">
        <mat-select-trigger>{{ selectedVisibilityLabelKey() | translate }}</mat-select-trigger>
        @for (option of visibilityOptions; track option.value) {
          <mat-option [value]="option.value">{{ option.labelKey | translate }}</mat-option>
        }
      </mat-select>
      <glxy-hint>{{ 'ADMINISTRATION.EMAIL_LABELING_SETTINGS.DEFAULT_INBOUND_VISIBILITY_HELP' | translate }}</glxy-hint>
    </glxy-form-field>
  </mat-card-content>
  <mat-card-actions>
    <button mat-flat-button color="primary" (click)="onSave()" [disabled]="!isFormValid()">
      {{ 'COMMON.SAVE' | translate }}
    </button>
    <button mat-stroked-button (click)="onCancel()">{{ 'COMMON.CANCEL' | translate }}</button>
  </mat-card-actions>
</mat-card>
